PluginRunner = require 'app/scripts/views/internal/plugins/plugin-runner'
PluginView = require 'app/scripts/views/plugin/plugin-view'
Promise = require 'bluebird'
_ = require 'underscore'
t = require('app/scripts/views/internal/teacup-with-helpers')()
xtend = require 'xtend'
{ IconQuietColor } = require '@trello/nachos'

template = t.renderable ({ icon, text, iconColor, iconColorClass }) ->
  if icon?
    t.span ".badge-icon.icon-sm.plugin-icon#{iconColorClass}",
      style: t.stylify
        'background-image': t.urlify t.addRecolorParam(icon, "?color=#{ iconColor }")
  if text
    t.span '.badge-text', ->
      t.text text

colorClasses =
  'blue': 'plugin-color-blue'
  'green': 'plugin-color-green'
  'orange': 'plugin-color-orange'
  'red': 'plugin-color-red'
  'yellow': 'plugin-color-yellow'
  'purple': 'plugin-color-purple'
  'pink': 'plugin-color-pink'
  'sky': 'plugin-color-sky'
  'lime': 'plugin-color-lime'
  'light-gray': 'plugin-color-light-gray'

allColorClasses = _.values(colorClasses).join(' ')

getColorClass = (color) ->
  colorClasses[color]

module.exports = class PluginBadgeView extends PluginView
  tagName: 'div'
  className: 'badge'

  initialize: ({ @pluginBadge }) ->

  renderBadge: (badge) ->
    @$el.html(template(badge))
    @$el

  render: ->
    badge = @pluginBadge
    colorClass = getColorClass(badge.color)
    useWhite = colorClass? && badge.color != 'light-gray'
    iconColor = if useWhite then 'fff' else IconQuietColor.substr(1).toLowerCase()
    iconColorClass = if useWhite then '.mod-invert' else '.mod-quiet'
    if badge.monochrome == false
      iconColorClass = '.mod-reset'

    $badge = @renderBadge(xtend badge, { iconColor, iconColorClass })
    # Remove any old colors
    $badge.removeClass(allColorClasses)
    if colorClass?
      $badge.addClass(colorClass)

    @

  # to avoid needing to remove and create brand new views
  # when updating a badge from cache, we allow it to be updated
  # in place and re-rendered
  updateBadge: (badge) ->
    if !_.isEqual(@pluginBadge, badge)
      @pluginBadge = badge
      @render(badge)
